import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import DataTable from 'components/organisms/DataTable'
import SearchField from 'components/atoms/SearchField'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import PaginationControl from 'components/organisms/PaginationControl'

import { manageGroupColumns } from './'

export const styles = theme => ({
  root: {},
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  inviteButton: {
    marginLeft: theme.spacing(3),
  },
  table: {
    marginTop: theme.spacing(6),
  },
})

const ManageGroups = ({
  groups,
  classes,
  filters,
  tableLoading,
  onPageChange,
  onSearchChange,
  onTableRowClick,
  onTableSortClick,
  onCreateGroupClick,
}) => (
  <div className={classes.root}>
    <div className={classes.header}>
      <Typography variant="h1">All Groups</Typography>
      <div style={{ display: 'inherit' }}>
        <SearchField onChange={onSearchChange} />
        <SubmitButton
          autoFocus
          size="medium"
          type="submit"
          color="primary"
          variant="primary"
          onClick={onCreateGroupClick}
          className={classes.inviteButton}>
            Create a group
        </SubmitButton>
      </div>
    </div>
    <DataTable
      key="Group table"
      dataProvider={groups}
      className={classes.table}
      tableLoading={tableLoading}
      columns={manageGroupColumns}
      onRowClick={onTableRowClick}
      onSortClick={onTableSortClick}
      emptyStateTitle="Looks like you need to create some groups!"
      emptyStateDescription="Create groups to help you see reporting on a specific set of traps for even better insights."
    />
    <PaginationControl
      pagination={filters.pagination}
      onPageChange={onPageChange}
    />
  </div>
)

ManageGroups.propTypes = {
  groups: PropTypes.object,
  classes: PropTypes.object,
  filters: PropTypes.object,
  tableLoading: PropTypes.bool,
  onPageChange: PropTypes.func,
  onSearchChange: PropTypes.func,
  onTableRowClick: PropTypes.func,
  onTableSortClick: PropTypes.func,
  onCreateGroupClick: PropTypes.func,
}

export default withStyles(styles)(ManageGroups)



// WEBPACK FOOTER //
// ./src/containers/groups/ManageGroups/ManageGroups.js